import i18next from 'i18next';

export const filterConfig = {
  locationType: [
    { label: i18next.t('InPerson', { ns: 'trackmanEvents' }), value: 'InPerson' },
    { label: i18next.t('Online', { ns: 'trackmanEvents' }), value: 'Online' },
  ],
  premiumEvent: [
    { label: i18next.t('Free', { ns: 'trackmanEvents' }), value: false },
    { label: i18next.t('Premium', { ns: 'trackmanEvents' }), value: true },
  ],
};
